import { render, staticRenderFns } from "./CustomerPopupContent.vue?vue&type=template&id=47c9ff73"
import script from "./CustomerPopupContent.vue?vue&type=script&lang=js"
export * from "./CustomerPopupContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports